<script lang="ts">
    import { api } from "../../../../api"
    import { actionApproval, login } from "../../../store"
    import { downloadFile } from "../../../utils"
    import Loader from "../../Loader.svelte"

    export let task: Task
    let load = false
    async function downloadTaskProtocol() {
        load = true
        api(
            "action",
            {
                method: "POST",
                useJwt: true,
                jwtToUse: $login.tokenString,
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            },
            {
                operation: "createTaskProtocol",
                id: task.id,
            }
        )
            .then((response) => {
                const file = response.data
                downloadFile(file, "Einsatzprotokoll.pdf")
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {
                load = false
            })
    }
</script>

{#if task.status == "inProgress" || !task.status}
    <span style="color:#E2010F; ">Erst alle Fahrer-Einsätze beenden!</span>
{:else if task.status == "completed"}
    <ul>
        <li>
            <button
                on:click|stopPropagation="{() => {
                    $actionApproval = {
                        modalTitle: 'Protokoll herunterladen',
                        modalText:
                            'Möchten Sie das Protokoll herunterladen? Die Ladezeit erhöht sich proportional zur Menge der angehängten Bilder im Protokoll.',
                        callback: downloadTaskProtocol,
                    }
                }}"
            >
                {#if load}
                    <Loader />
                {:else}
                    <span>
                        <img
                            alt="icon"
                            src="../../../../../assets/icons/solar_download-minimalistic-outline.svg"
                        />
                    </span>
                    <span>Download</span>
                {/if}
            </button>
        </li>
    </ul>
{/if}

<style lang="less">
    span {
        white-space: wrap;
        font-size: 0.8rem;
    }
    button {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        color: var(--text-100);
    }
</style>
